import { Link } from 'react-router-dom';

import ImageLightbox from '../ImageLightbox/ImageLightbox';
import { homeGalleryImages } from '../../data/homeImages';
import { useImageLightbox } from '../../hooks/useImageLightbox';

import './AboutVilla.css';

function AboutVilla() {
  const lightbox = useImageLightbox(homeGalleryImages);

  return (
    <section className="about-villa">
      <iframe
        src="https://www.youtube.com/embed/Arq2zDrKuFo?si=EhbGbQ9U2TtdXg6p"
        title="Villa Mandragora video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />

      <div className="about-villa__content">
        <span className="about-villa__location">
          Orahovac, Kotor Bay, Montenegro
        </span>
        <h2 className="about-villa__title">Villa Mandragora</h2>
        <p className="about-villa__text">
          Villa Mandragora is located between Kotor and Perast on the Bay of Kotor, where historic coastal towns, steep mountains and the sea come together within a remarkably compact landscape.
        </p>
        <p className="about-villa__text">
          Set in Orahovac, the villa offers privacy, open views of the bay and a quiet base from which to explore the surrounding coast.
        </p>
      </div>

      <div className="villa-highlights">
        {[
          ['8', 'Guests'],
          ['4', 'Bedrooms'],
          ['5', 'Bathrooms'],
          ['6', 'Parking spaces'],
        ].map(([number, label]) => (
          <div className="villa-highlights__item" key={label}>
            <span className="villa-highlights__number">{number}</span>
            <span className="villa-highlights__label">{label}</span>
          </div>
        ))}
      </div>

      <div className="villa-amenities">
        {[
          ['Yacht berth', 'For yachts up to 25 m'],
          ['Fitness studio', 'Dedicated fitness space'],
          ['Wellness area', 'Sauna and relaxation space'],
          ['Swimming pool', 'With panoramic bay views'],
        ].map(([title, text]) => (
          <div className="villa-amenities__item" key={title}>
            <h3 className="villa-amenities__title">{title}</h3>
            <p className="villa-amenities__text">{text}</p>
          </div>
        ))}
      </div>

      <div className="villa-gallery">
        <div className="villa-gallery__header">
          <span className="villa-gallery__label">Gallery</span>
        </div>

        <div className="villa-gallery__grid">
          {homeGalleryImages.map((image, index) => (
            <button
              className="villa-gallery__item"
              type="button"
              key={image.id}
              onClick={() => lightbox.open(index)}
              aria-label={`Open ${image.alt}`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="villa-gallery__image"
                loading="lazy"
                decoding="async"
              />
            </button>
          ))}
        </div>

        <div className="villa-gallery__action">
          <Link to="/gallery" className="villa-gallery__link">
            View full gallery
          </Link>
        </div>
      </div>

      <ImageLightbox
        activeIndex={lightbox.activeIndex}
        images={homeGalleryImages}
        isOpen={lightbox.isOpen}
        onClose={lightbox.close}
      />
    </section>
  );
}

export default AboutVilla;
